import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServerValidationErrorComponent } from './components/server-validation-error/server-validation-error.component';
import { ValidationErrorsComponent } from './components/validation-error/validation-error.component';
import { SpinnerModule } from './modules/spinner/spinner.module';

@NgModule({
  declarations: [
    ServerValidationErrorComponent,
    ValidationErrorsComponent
  ],
  imports: [
    SpinnerModule,
    CommonModule
  ],
  exports: [
    ServerValidationErrorComponent,
    ValidationErrorsComponent,
    SpinnerModule
  ],
})

export class SharedModule { }
